<template>
  <div>暂无</div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss"></style>
